import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-serif text-xl text-white font-bold mb-3">{title}</h2>
    {children}
  </section>
);

const Datenschutz = () => {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <Section title="1. Verantwortliche Person">
        <p>
          Verantwortliche Person im Sinne der Datenschutzgesetze, insbesondere der
          EU-Datenschutzgrundverordnung (DSGVO):
        </p>
        <p className="mt-2 text-gray-300">
          Marc Arndt<br />
          c/o Schürpf Consulting, Chli Ebnet 1, CH-6403 Küssnacht am Rigi, Schweiz<br />
          E-Mail:{' '}
          <a href="mailto:gcvllc@gmail.com" className="text-gold hover:underline">
            gcvllc@gmail.com
          </a>
        </p>
      </Section>

      <Section title="2. Ihre Rechte">
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
          <li>Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        </ul>
        <p className="mt-3">
          Zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an die oben genannte
          E-Mail-Adresse.
        </p>
      </Section>

      <Section title="3. Erfassung allgemeiner Informationen">
        <p>
          Wenn Sie auf unsere Website zugreifen, werden automatisch Informationen allgemeiner
          Natur erfasst. Diese Informationen (Server-Logfiles) beinhalten etwa die Art des
          Webbrowsers, das verwendete Betriebssystem, den Domainnamen Ihres
          Internet-Service-Providers und Ähnliches. Dies sind ausschließlich Informationen,
          welche keine Rückschlüsse auf Ihre Person zulassen.
        </p>
      </Section>

      <Section title="4. Kontaktformular">
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
          dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
          Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
          Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Rechtsgrundlage ist Art.
          6 Abs. 1 lit. b DSGVO.
        </p>
      </Section>

      <Section title="5. Amazon Partnerprogramm">
        <div className="bg-gold/5 border border-gold/20 rounded-xl p-5">
          <p>
            Diese Website nimmt am Amazon-Partnerprogramm teil, einem
            Affiliate-Werbeprogramm, das für Websites konzipiert wurde, um Werbekostenerstattungen
            durch Werbung und Verlinkung zu Amazon.de zu verdienen. Amazon setzt Cookies ein,
            um die Herkunft der Bestellungen nachvollziehen zu können. Dabei kann Amazon
            erkennen, dass Sie den Partnerlink auf dieser Website geklickt haben. Die
            Speicherung von „Amazon-Cookies" erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
            DSGVO. Weitere Informationen zur Datennutzung durch Amazon finden Sie in der{' '}
            <a
              href="https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold hover:underline"
            >
              Datenschutzerklärung von Amazon
            </a>
            .
          </p>
        </div>
      </Section>

      <Section title="6. Cookies">
        <p>
          Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser
          auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot
          nutzerfreundlicher, effektiver und sicherer zu machen. Einige Cookies sind
          „Session-Cookies". Solche Cookies werden nach Ende Ihrer Browser-Sitzung von selbst
          gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese
          löschen. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von
          Cookies informiert werden und Cookies nur im Einzelfall erlauben.
        </p>
      </Section>

      <Section title="7. Änderungen dieser Datenschutzerklärung">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie
          stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer
          Leistungen in der Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt
          dann die neue Datenschutzerklärung.
        </p>
        <p className="mt-2 text-gray-500 text-xs">Stand: {new Date().getFullYear()}</p>
      </Section>
    </LegalLayout>
  );
};

export default Datenschutz;